// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../static/fonts/Waldenburg/KMR-Waldenburg-Buch.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../static/fonts/Waldenburg/KMR-Waldenburg-MagerKursiv.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../static/fonts/Waldenburg/KMR-Waldenburg-Fett.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../static/fonts/Waldenburg/KMR-Waldenburg-Halbfett.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../static/fonts/Waldenburg/KMR-Waldenburg-Mager.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../static/fonts/Waldenburg/Waldenburg-HalbfettKursiv.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../static/fonts/PP Fragment/PPFragment-SansRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../static/fonts/PP Fragment/PPFragment-SansLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../static/fonts/PP Fragment/PPFragment-GlareRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../static/fonts/PP Fragment/PPFragment-SerifRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../static/fonts/PP Fragment/PPFragment-SerifLight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../static/fonts/PP Eiko/PPEiko-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../static/fonts/PP Eiko/PPEiko-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: "PP Fragment Sans"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

h1 {
  font-size: 2.25rem;
}

h2 {
  font-size: 1.875rem;
}

h3 {
  font-size: 1.5rem;
}

h4 {
  font-size: 1.25rem;
}.\\!container {
  width: 100% !important;
}.container {
  width: 100%;
}@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}.absolute {
  position: absolute;
}.relative {
  position: relative;
}.left-\\[-15rem\\] {
  left: -15rem;
}.right-\\[-15rem\\] {
  right: -15rem;
}.top-24 {
  top: 6rem;
}.top-\\[-3rem\\] {
  top: -3rem;
}.top-\\[-50\\%\\] {
  top: -50%;
}.z-10 {
  z-index: 10;
}.z-20 {
  z-index: 20;
}.mx-auto {
  margin-left: auto;
  margin-right: auto;
}.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}.flex {
  display: flex;
}.h-7 {
  height: 1.75rem;
}.h-\\[15\\.625rem\\] {
  height: 15.625rem;
}.h-\\[4\\.875rem\\] {
  height: 4.875rem;
}.h-\\[5\\.375rem\\] {
  height: 5.375rem;
}.h-full {
  height: 100%;
}.h-screen {
  height: 100vh;
}.w-44 {
  width: 11rem;
}.w-64 {
  width: 16rem;
}.w-\\[14rem\\] {
  width: 14rem;
}.w-\\[21\\.875rem\\] {
  width: 21.875rem;
}.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}.w-full {
  width: 100%;
}.w-screen {
  width: 100vw;
}.max-w-\\[30rem\\] {
  max-width: 30rem;
}.flex-shrink-0 {
  flex-shrink: 0;
}.flex-grow {
  flex-grow: 1;
}.cursor-pointer {
  cursor: pointer;
}.flex-row {
  flex-direction: row;
}.flex-col {
  flex-direction: column;
}.items-start {
  align-items: flex-start;
}.items-center {
  align-items: center;
}.justify-end {
  justify-content: flex-end;
}.justify-center {
  justify-content: center;
}.justify-between {
  justify-content: space-between;
}.gap-10 {
  gap: 2.5rem;
}.gap-16 {
  gap: 4rem;
}.gap-2 {
  gap: 0.5rem;
}.gap-20 {
  gap: 5rem;
}.gap-4 {
  gap: 1rem;
}.gap-5 {
  gap: 1.25rem;
}.gap-6 {
  gap: 1.5rem;
}.overflow-y-auto {
  overflow-y: auto;
}.overflow-x-hidden {
  overflow-x: hidden;
}.whitespace-nowrap {
  white-space: nowrap;
}.rounded-lg {
  border-radius: 0.5rem;
}.rounded-xl {
  border-radius: 0.75rem;
}.border {
  border-width: 1px;
}.border-white\\/\\[12\\%\\] {
  border-color: rgba(255, 255, 255, 0.12);
}.bg-blue-jeans-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(94, 169, 255, 1);
  background-color: rgba(94, 169, 255, var(--tw-bg-opacity, 1));
}.bg-cultured-white {
  --tw-bg-opacity: 1;
  background-color: rgba(246, 247, 240, 1);
  background-color: rgba(246, 247, 240, var(--tw-bg-opacity, 1));
}.bg-jungle-green {
  --tw-bg-opacity: 1;
  background-color: rgba(13, 28, 43, 1);
  background-color: rgba(13, 28, 43, var(--tw-bg-opacity, 1));
}.bg-rich-black {
  --tw-bg-opacity: 1;
  background-color: rgba(5, 10, 16, 1);
  background-color: rgba(5, 10, 16, var(--tw-bg-opacity, 1));
}.p-10 {
  padding: 2.5rem;
}.p-8 {
  padding: 2rem;
}.\\!px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}.pt-36 {
  padding-top: 9rem;
}.text-center {
  text-align: center;
}.font-pp-eiko {
  font-family: "PP Eiko";
}.font-pp-fragment-sans {
  font-family: "PP Fragment Sans";
}.font-pp-fragment-serif {
  font-family: "PP Fragment Serif";
}.font-waldenburg {
  font-family: "Waldenburg";
}.\\!text-2xl {
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}.\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}.text-\\[2\\.75rem\\] {
  font-size: 2.75rem;
}.text-\\[2\\.85rem\\] {
  font-size: 2.85rem;
}.text-\\[2rem\\] {
  font-size: 2rem;
}.text-\\[3\\.25rem\\] {
  font-size: 3.25rem;
}.text-\\[3\\.75rem\\] {
  font-size: 3.75rem;
}.text-\\[4\\.375rem\\] {
  font-size: 4.375rem;
}.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}.font-light {
  font-weight: 300;
}.font-normal {
  font-weight: 400;
}.font-semibold {
  font-weight: 600;
}.italic {
  font-style: italic;
}.leading-tighter {
  line-height: 1.1;
}.text-\\[\\#020000\\] {
  --tw-text-opacity: 1;
  color: rgba(2, 0, 0, 1);
  color: rgba(2, 0, 0, var(--tw-text-opacity, 1));
}.text-blue-jeans-50 {
  --tw-text-opacity: 1;
  color: rgba(253, 255, 239, 1);
  color: rgba(253, 255, 239, var(--tw-text-opacity, 1));
}.text-blue-jeans-500 {
  --tw-text-opacity: 1;
  color: rgba(94, 169, 255, 1);
  color: rgba(94, 169, 255, var(--tw-text-opacity, 1));
}.text-cultured-white {
  --tw-text-opacity: 1;
  color: rgba(246, 247, 240, 1);
  color: rgba(246, 247, 240, var(--tw-text-opacity, 1));
}.text-cultured-white\\/80 {
  color: rgba(246, 247, 240, 0.8);
}.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}.no-scrollbar::-webkit-scrollbar{display:none}.no-scrollbar{-ms-overflow-style:none;scrollbar-width:none}@font-face{font-family:"Waldenburg";font-display:block;font-weight:400;src:url(${___CSS_LOADER_URL_REPLACEMENT_0___})}@font-face{font-family:"Waldenburg";font-style:italic;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_1___})}@font-face{font-family:"Waldenburg";font-weight:700;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_2___})}@font-face{font-family:"Waldenburg";font-weight:600;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_3___})}@font-face{font-family:"Waldenburg";font-weight:500;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_0___})}@font-face{font-family:"Waldenburg";font-weight:300;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_4___})}@font-face{font-family:"Waldenburg";font-style:italic;font-weight:bold;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_5___})}@font-face{font-family:"PP Fragment Sans";font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_6___})}@font-face{font-family:"PP Fragment Sans";font-weight:300;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_7___})}@font-face{font-family:"PP Fragment Glare";font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_8___})}@font-face{font-family:"PP Fragment Serif";font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_9___})}@font-face{font-family:"PP Fragment Serif";font-weight:300;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_10___})}@font-face{font-family:"PP Eiko";font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_11___})}@font-face{font-family:"PP Eiko";font-style:italic;font-display:block;src:url(${___CSS_LOADER_URL_REPLACEMENT_12___})}html {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity, 1));font-size:16px;
}a {
  --tw-text-opacity: 1;
  color: rgba(246, 247, 240, 1);
  color: rgba(246, 247, 240, var(--tw-text-opacity, 1));
}a:hover {
  cursor: pointer;
  --tw-text-opacity: 1;
  color: rgba(147, 197, 255, 1);
  color: rgba(147, 197, 255, var(--tw-text-opacity, 1));
}a:active {
  --tw-text-opacity: 1;
  color: rgba(94, 169, 255, 1);
  color: rgba(94, 169, 255, var(--tw-text-opacity, 1));
}thead th {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgba(126, 126, 126, 1);
  color: rgba(126, 126, 126, var(--tw-text-opacity, 1));
  text-transform: capitalize;
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: left;
}tbody td {
  font-weight: 400;
  text-align: left;
}tr td:first-child{border-top-left-radius:8px}tr td:last-child{border-top-right-radius:8px}tr td:first-child{border-bottom-left-radius:8px}tr td:last-child{border-bottom-right-radius:8px}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.accent-shadow{box-shadow:0px 4px 40px 0px rgba(94,169,255,.3019607843)}.text-accent-shadow{text-shadow:0px 4px 40px rgba(94,169,255,.3019607843)}.gradient-border{position:relative}.gradient-border::before{content:"";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:.75rem;background:linear-gradient(134.51deg, rgba(157, 203, 255, 0.5019607843) 12.41%, rgba(56, 101, 153, 0.5019607843) 32.69%) border-box;-webkit-mask:linear-gradient(#000 0, #000 0) content-box,linear-gradient(#000 0, #000 0);mask:linear-gradient(#000 0, #000 0) content-box,linear-gradient(#000 0, #000 0);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude;border:1px solid rgba(0,0,0,0)}.gradient-border:hover::before{background:linear-gradient(235.01deg, #9DCBFF 14.6%, #386599 32.69%) border-box}.radial-gradient{background:radial-gradient(78.23% 78.23% at 51.39% 100%, rgba(82, 161, 251, 0.8117647059) 20%, rgba(5, 10, 16, 0.7) 100%)}.hover\\:bg-\\[\\#1C324C\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(28, 50, 76, 1);
  background-color: rgba(28, 50, 76, var(--tw-bg-opacity, 1));
}.hover\\:bg-blue-jeans-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(121, 183, 255, 1);
  background-color: rgba(121, 183, 255, var(--tw-bg-opacity, 1));
}.hover\\:bg-blue-jeans-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(253, 255, 239, 1);
  background-color: rgba(253, 255, 239, var(--tw-bg-opacity, 1));
}@media not all and (min-width: 640px) {

  .max-sm\\:left-\\[-4rem\\] {
    left: -4rem;
  }

  .max-sm\\:right-\\[-4rem\\] {
    right: -4rem;
  }

  .max-sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .max-sm\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .max-sm\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .max-sm\\:mt-8 {
    margin-top: 2rem;
  }

  .max-sm\\:hidden {
    display: none;
  }

  .max-sm\\:h-16 {
    height: 4rem;
  }

  .max-sm\\:h-52 {
    height: 13rem;
  }

  .max-sm\\:h-\\[3\\.5rem\\] {
    height: 3.5rem;
  }

  .max-sm\\:h-fit {
    height: -moz-fit-content;
    height: fit-content;
  }

  .max-sm\\:w-36 {
    width: 9rem;
  }

  .max-sm\\:w-52 {
    width: 13rem;
  }

  .max-sm\\:w-fit {
    width: -moz-fit-content;
    width: fit-content;
  }

  .max-sm\\:flex-row {
    flex-direction: row;
  }

  .max-sm\\:flex-col {
    flex-direction: column;
  }

  .max-sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .max-sm\\:justify-start {
    justify-content: flex-start;
  }

  .max-sm\\:justify-center {
    justify-content: center;
  }

  .max-sm\\:gap-2 {
    gap: 0.5rem;
  }

  .max-sm\\:gap-3 {
    gap: 0.75rem;
  }

  .max-sm\\:gap-4 {
    gap: 1rem;
  }

  .max-sm\\:gap-8 {
    gap: 2rem;
  }

  .max-sm\\:p-6 {
    padding: 1.5rem;
  }

  .max-sm\\:p-8 {
    padding: 2rem;
  }

  .max-sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .max-sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .max-sm\\:\\!text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }

  .max-sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .max-sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .max-sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .max-sm\\:text-\\[1\\.75rem\\] {
    font-size: 1.75rem;
  }

  .max-sm\\:text-\\[3rem\\] {
    font-size: 3rem;
  }

  .max-sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .max-sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .max-sm\\:opacity-50 {
    opacity: 0.5;
  }
}@media (min-width: 768px) {

  .md\\:hidden {
    display: none;
  }
}@media (min-width: 1024px) {

  .lg\\:hidden {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Landing/landing-page.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,0BAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA,CACA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA,CAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA,CACA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,gBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,uBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA,uCAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA,qCAAA;EAAA;AAAA,CAAA;EAAA,kBAAA;EAAA,oCAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,iBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,4BAAA;EAAA;AAAA,CAAA;EAAA,0BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,eAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA,mBAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA,CAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA,CAAA;EAAA;AAAA,CAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA,CAmGE,iCACE,YAAA,CAGF,cACE,uBAAA,CACA,oBAAA,CAvGJ,WACE,wBAAA,CACA,kBAAA,CACA,eAAA,CACA,2CAAA,CAGF,WACE,wBAAA,CACA,iBAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,wBAAA,CACA,eAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,wBAAA,CACA,eAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,wBAAA,CACA,eAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,wBAAA,CACA,eAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,wBAAA,CACA,iBAAA,CACA,gBAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,8BAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,8BAAA,CACA,eAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,+BAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,+BAAA,CACA,kBAAA,CACA,2CAAA,CAGF,WACE,+BAAA,CACA,eAAA,CACA,kBAAA,CACA,4CAAA,CAGF,WACE,qBAAA,CACA,kBAAA,CACA,4CAAA,CAGF,WACE,qBAAA,CACA,iBAAA,CACA,kBAAA,CACA,4CAAA,CAgBA;EAAA,oBAAA;EAAA,6BAAA;EAAA,qDAAA,CACA;AADA,CAKA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA,CAGE;EAAA,eAAA;EACA,oBAAA;EAAA,6BAAA;EAAA;AADA,CAKA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA,CAKF;EAAA,gBAAA;EACA,oBAAA;EAAA,6BAAA;EAAA,qDAAA;EACA,0BAAA;EACA,kBAAA;EAAA,iBAAA;EACA;AAJA,CAQA;EAAA,gBAAA;EACA;AADA,CAIF,kBAAA,0BAAA,CACA,iBAAA,2BAAA,CAEA,kBAAA,6BAAA,CACA,iBAAA,8BAAA,CAEA,kEAEE,uBAAA,CACA,QAAA,CAGF,eACE,wDAAA,CAGF,oBACE,qDAAA,CAGF,iBACE,iBAAA,CAEA,yBACE,UAAA,CACA,iBAAA,CACA,KAAA,CAAA,OAAA,CAAA,QAAA,CAAA,MAAA,CACA,oBAAA,CACA,mIAAA,CACA,wFACQ,CADR,gFACQ,CADR,4EACQ,CADR,oEACQ,CAER,0BAAA,CAAA,sBAAA,CACA,8BAAA,CAIA,+BACE,+EAAA,CAKN,iBACE,yHAAA,CA1LF;EAAA,kBA0LE;EA1LF,qCA0LE;EA1LF;AA0LE,CA1LF;EAAA,kBA0LE;EA1LF,wCA0LE;EA1LF;AA0LE,CA1LF;EAAA,kBA0LE;EA1LF,wCA0LE;EA1LF;AA0LE,CA1LF;;EAAA;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA,iBA0LE;IA1LF;EA0LE;;EA1LF;IAAA,eA0LE;IA1LF;EA0LE;;EA1LF;IAAA,gBA0LE;IA1LF;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA,wBA0LE;IA1LF;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA,uBA0LE;IA1LF;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA,kBA0LE;IA1LF;EA0LE;;EA1LF;IAAA,iBA0LE;IA1LF;EA0LE;;EA1LF;IAAA,8BA0LE;IA1LF;EA0LE;;EA1LF;IAAA,iBA0LE;IA1LF;EA0LE;;EA1LF;IAAA,mBA0LE;IA1LF;EA0LE;;EA1LF;IAAA,kBA0LE;IA1LF;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA;EA0LE;;EA1LF;IAAA,mBA0LE;IA1LF;EA0LE;;EA1LF;IAAA,kBA0LE;IA1LF;EA0LE;;EA1LF;IAAA;EA0LE;AAAA,CA1LF;;EAAA;IAAA;EA0LE;AAAA,CA1LF;;EAAA;IAAA;EA0LE;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n  font-family: 'Waldenburg';\n  font-display: block;\n  font-weight: 400;\n  src: url('../../../static/fonts/Waldenburg/KMR-Waldenburg-Buch.otf');\n}\n\n@font-face {\n  font-family: 'Waldenburg';\n  font-style: italic;\n  font-display: block;\n  src: url('../../../static/fonts/Waldenburg/KMR-Waldenburg-MagerKursiv.otf');\n}\n\n@font-face {\n  font-family: 'Waldenburg';\n  font-weight: 700;\n  font-display: block;\n  src: url('../../../static/fonts/Waldenburg/KMR-Waldenburg-Fett.otf');\n}\n\n@font-face {\n  font-family: 'Waldenburg';\n  font-weight: 600;\n  font-display: block;\n  src: url('../../../static/fonts/Waldenburg/KMR-Waldenburg-Halbfett.otf');\n}\n\n@font-face {\n  font-family: 'Waldenburg';\n  font-weight: 500;\n  font-display: block;\n  src: url('../../../static/fonts/Waldenburg/KMR-Waldenburg-Buch.otf');\n}\n\n@font-face {\n  font-family: 'Waldenburg';\n  font-weight: 300;\n  font-display: block;\n  src: url('../../../static/fonts/Waldenburg/KMR-Waldenburg-Mager.otf');\n}\n\n@font-face {\n  font-family: 'Waldenburg';\n  font-style: italic;\n  font-weight: bold;\n  font-display: block;\n  src: url('../../../static/fonts/Waldenburg/Waldenburg-HalbfettKursiv.otf');\n}\n\n@font-face {\n  font-family: 'PP Fragment Sans';\n  font-display: block;\n  src: url(\"../../../static/fonts/PP Fragment/PPFragment-SansRegular.otf\");\n}\n\n@font-face {\n  font-family: 'PP Fragment Sans';\n  font-weight: 300;\n  font-display: block;\n  src: url(\"../../../static/fonts/PP Fragment/PPFragment-SansLight.otf\");\n}\n\n@font-face {\n  font-family: 'PP Fragment Glare';\n  font-display: block;\n  src: url(\"../../../static/fonts/PP Fragment/PPFragment-GlareRegular.otf\");\n}\n\n@font-face {\n  font-family: 'PP Fragment Serif';\n  font-display: block;\n  src: url(\"../../../static/fonts/PP Fragment/PPFragment-SerifRegular.otf\");\n}\n\n@font-face {\n  font-family: 'PP Fragment Serif';\n  font-weight: 300;\n  font-display: block;\n  src: url(\"../../../static/fonts/PP Fragment/PPFragment-SerifLight.otf\");\n}\n\n@font-face {\n  font-family: 'PP Eiko';\n  font-display: block;\n  src: url(\"../../../static/fonts/PP Eiko/PPEiko-Regular.otf\");\n}\n\n@font-face {\n  font-family: 'PP Eiko';\n  font-style: italic;\n  font-display: block;\n  src: url(\"../../../static/fonts/PP Eiko/PPEiko-RegularItalic.otf\");\n}\n\n@layer utilities {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  .no-scrollbar::-webkit-scrollbar {\n    display: none;\n  }\n  /* Hide scrollbar for IE, Edge and Firefox */\n  .no-scrollbar {\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n  }\n}\n\nhtml {\n  @apply text-white;\n  font-size: 16px;\n}\n\na {\n  @apply text-cultured-white;\n\n  &:hover {\n    @apply cursor-pointer;\n    @apply text-blue-jeans-300;\n  }\n\n  &:active {\n    @apply text-blue-jeans-500;\n  }\n}\n\nthead th {\n  @apply font-semibold;\n  @apply text-grey;\n  @apply capitalize;\n  @apply text-xs;\n  @apply text-left;\n}\n\ntbody td {\n  @apply font-normal;\n  @apply text-left;\n}\n\ntr td:first-child { border-top-left-radius: 8px; }\ntr td:last-child { border-top-right-radius: 8px; }\n\ntr td:first-child { border-bottom-left-radius: 8px; }\ntr td:last-child { border-bottom-right-radius: 8px; }\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.accent-shadow {\n  box-shadow: 0px 4px 40px 0px #5EA9FF4D;\n}\n\n.text-accent-shadow {\n  text-shadow: 0px 4px 40px #5EA9FF4D;\n}\n\n.gradient-border {\n  position: relative;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    border-radius: .75rem;\n    background: linear-gradient(134.51deg, #9DCBFF80 12.41%, #38659980 32.69%) border-box;\n    mask:\n            linear-gradient(#000 0 0) content-box,\n            linear-gradient(#000 0 0);\n    mask-composite: exclude;\n    border: 1px solid transparent;\n  }\n\n  &:hover {\n    &::before {\n      background: linear-gradient(235.01deg, #9DCBFF 14.6%, #386599 32.69%) border-box;\n    }\n  }\n}\n\n.radial-gradient {\n  background: radial-gradient(78.23% 78.23% at 51.39% 100%, #52A1FBCF 20%, rgba(5, 10, 16, 0.7) 100%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
